import { FC } from "react";
import { Box } from "@mui/material";
import { ResourceExplorerCostsDateDetails } from "@/services/cloudchipr.api";
import { formatDate } from "@/utils/helpers/date-time/datetime-format";
import { TooltipText } from "@/components/common/TooltipText";

interface BillingExplorerWidgetNoDataCellProps {
  dates?: ResourceExplorerCostsDateDetails;
  alignment?: "left" | "right";
}

export const BillingExplorerWidgetNoDataCell: FC<
  BillingExplorerWidgetNoDataCellProps
> = ({ dates, alignment = "left" }) => {
  const fromDate = formatDate(dates?.from_date ?? "", { type: "date" });
  const toDate = formatDate(dates?.to_date ?? "", {
    type: "date",
  });

  return (
    <Box textAlign={alignment} pr={alignment === "right" ? 10 : 0}>
      <TooltipText
        tooltipTitle={`No data for Previous Period - ${fromDate} - ${toDate}`}
      >
        N/A
      </TooltipText>
    </Box>
  );
};
